import { SubmitButton } from 'components/common/buttons/SubmitButton';
import PdfForm from 'components/Pdf/PdfForm';
import {
    buildInvoiceGroups,
    buildSpecialProjectGroups,
    getInvoiceGroupByConfig,
    getSpecialProjectGroupByConfig,
} from 'helpers/invoiceGrouping';
import ExcelJS from 'exceljs';
import jsPDF from 'jspdf';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchGeneratedInvoices, invoicesSelector } from 'slices/invoiceSlice';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const AllPdfView = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();
    const invoiceRef = useRef(null);
    const [buttonLoader, setButtonLoader] = useState(false);

    const { generatedInvoices, loader } = useSelector(invoicesSelector);
    const generatedInvoice = generatedInvoices?.find(t => t.id === Number(id));
    const invoiceNumber = generatedInvoice?.invoice_number;
    const clientData = generatedInvoice?.client || generatedInvoice;

    useEffect(() => {
        dispatch(fetchGeneratedInvoices(1, { invoice_id: id }));
    }, [dispatch]);

    const show = (value) => value !== null && value !== undefined && value !== '' && value !== 'N/A';

    const formatCurrency = (value) => {
        const numericValue = Number(value || 0);
        return Number.isFinite(numericValue) ? numericValue.toFixed(2) : '0.00';
    };

    const formatDate = (value) => {
        if (!value) return '';
        return new Date(value).toLocaleDateString('en-GB');
    };

    const getExceededTime = (scheduledDate, scheduledEnd, actualDate, actualEnd) => {
        if (!scheduledDate || !scheduledEnd || !actualDate || !actualEnd) return null;

        const scheduledEndMoment = moment(`${scheduledDate} ${scheduledEnd}`, 'YYYY-MM-DD HH:mm:ss');
        const actualEndMoment = moment(`${actualDate} ${actualEnd}`, 'YYYY-MM-DD HH:mm:ss');

        if (!scheduledEndMoment.isValid() || !actualEndMoment.isValid()) return null;

        const exceededSeconds = actualEndMoment.diff(scheduledEndMoment, 'seconds');
        if (exceededSeconds <= 0) return null;

        return moment.utc(exceededSeconds * 1000).format('HH:mm:ss');
    };

    const getFullDuration = (actualStartDate, actualStartTime, actualEndDate, actualEndTime) => {
        if (!actualStartDate || !actualStartTime || !actualEndDate || !actualEndTime) return null;

        const startMoment = moment(`${actualStartDate} ${actualStartTime}`, 'YYYY-MM-DD HH:mm:ss');
        const endMoment = moment(`${actualEndDate} ${actualEndTime}`, 'YYYY-MM-DD HH:mm:ss');

        if (!startMoment.isValid() || !endMoment.isValid()) return null;

        const durationMinutes = endMoment.diff(startMoment, 'minutes');
        const hours = Math.floor(durationMinutes / 60);
        const minutes = durationMinutes % 60;

        if (hours > 0 && minutes > 0) return `${hours} hour ${minutes} minute`;
        if (hours > 0) return `${hours} hour`;
        if (minutes > 0) return `${minutes} minute`;
        return '0 minute';
    };

    const renderActualStartTime = (checkinDate, checkinTime, checkoutDate, checkoutTime) => {
        if (!checkinTime || !checkinDate) return null;

        const crossesMidnight = checkoutDate &&
            moment(checkoutDate).format('YYYY-MM-DD') !== moment(checkinDate).format('YYYY-MM-DD');

        if (crossesMidnight) {
            return {
                label: 'Actual Start Date Time',
                value: `${moment(checkinDate).format('DD/MM/YYYY')} ${moment(checkinTime, 'HH:mm:ss').format('h:mm A')}`
            };
        }

        return {
            label: 'Actual Start Time',
            value: moment(checkinTime, 'HH:mm:ss').format('h:mm A'),
        };
    };

    const getScheduledStartTime = (date, startTime, endTime, timezone) => {
        if (!date || !startTime) return null;

        const crossesMidnight = endTime &&
            moment(endTime, 'HH:mm:ss').isBefore(moment(startTime, 'HH:mm:ss'));

        const timezoneName = timezone?.name;
        const dateTime = timezoneName
            ? moment.tz(`${date} ${startTime}`, 'YYYY-MM-DD HH:mm:ss', timezoneName)
            : moment(`${date} ${startTime}`, 'YYYY-MM-DD HH:mm:ss');

        const formattedTime = dateTime.format('h:mm A');
        const timezoneInfo = timezoneName
            ? ` (${dateTime.format('z')} / GMT${dateTime.format('Z')})`
            : '';

        if (crossesMidnight) {
            return {
                label: t('invoice.scheduledStartDateTime'),
                value: `${dateTime.format('DD/MM/YYYY')} ${formattedTime}${timezoneInfo}`,
            };
        }

        return {
            label: t('invoice.scheduledStartTime'),
            value: `${formattedTime}${timezoneInfo}`,
        };
    };

    // const handleGeneratePdf = () => {
    //     if (!invoiceNumber) {
    //         toast.error("Invoice number not found!", {
    //             className: "errorToast",
    //         });
    //         return;
    //     }

    //     setButtonLoader(true);
    //     const doc = new jsPDF('p', 'pt', 'a4');

    //     // doc.html(invoiceRef.current, {
    //     //     callback: function (doc) {
    //     //         doc.save(`${invoiceNumber}.pdf`);
    //     //         toast.success("Invoice downloaded successfully!", {
    //     //             className: "successToast",
    //     //         });
    //     //         setButtonLoader(false);
    //     //     },
    //     //     margin: [7, 7, 7, 7],
    //     //     x: 7,
    //     //     y: 7,
    //     //     autoPaging: 'text',
    //     //     html2canvas: {
    //     //         scale: 0.73,
    //     //         useCORS: true,
    //     //     },
    //     // });


    //     doc.html(invoiceRef.current, {
    //         // Text Watermeak
    //         callback: function (doc) {

    //             const totalPages = doc.internal.getNumberOfPages();

    //             for (let i = 1; i <= totalPages; i++) {
    //                 doc.setPage(i);

    //                 if (doc.GState) {
    //                     doc.setGState(new doc.GState({ opacity: 0.12 }));
    //                 }

    //                 doc.setFontSize(60);
    //                 doc.setTextColor(180,180,180);

    //                 doc.text(
    //                     "MayaBridge",
    //                     doc.internal.pageSize.getWidth()/2,
    //                     doc.internal.pageSize.getHeight()/2,
    //                     {
    //                         align: "center",
    //                         angle: 45
    //                     }
    //                 );
    //             }

    //             doc.save(`${invoiceNumber}.pdf`);

    //             setButtonLoader(false);
    //         },

    //         margin: [7,7,7,7],
    //         x: 7,
    //         y: 7,
    //         autoPaging: "text",

    //         html2canvas: {
    //             scale: 0.73,
    //             useCORS: true,
    //         }
    //     });
    // };

    const handleGeneratePdf = () => {
        if (!invoiceNumber) {
            toast.error("Invoice number not found!", {
                className: "errorToast",
            });
            return;
        }

        setButtonLoader(true);

        const img = new Image();
        img.src = "/images/watermark-dark.png";

        img.onload = () => {
            const doc = new jsPDF('p', 'pt', 'a4');

            doc.html(invoiceRef.current, {
                callback: function (doc) {
                    const totalPages = doc.internal.getNumberOfPages();
                    
                    const pageWidth = doc.internal.pageSize.getWidth();
                    const pageHeight = doc.internal.pageSize.getHeight();

                    const imgWidth = 300; 
                    const imgHeight = (img.height / img.width) * imgWidth;

                    const x = (pageWidth - imgWidth) / 2;
                    const y = (pageHeight - imgHeight) / 2;

                    for (let i = 1; i <= totalPages; i++) {
                        doc.setPage(i);

                        if (doc.saveGraphicsState) {
                            doc.saveGraphicsState();
                        }

                        if (doc.GState) {
                            doc.setGState(new doc.GState({ opacity: 0.15 }));
                        }

                        doc.addImage(
                            img, 
                            'PNG',
                            x, 
                            y, 
                            imgWidth, 
                            imgHeight
                        );

                        if (doc.restoreGraphicsState) {
                            doc.restoreGraphicsState();
                        }
                    }

                    doc.save(`${invoiceNumber}.pdf`);
                    
                    toast.success("Invoice downloaded successfully!", {
                        className: "successToast",
                    });
                    setButtonLoader(false);
                },

                margin: [7, 7, 7, 7],
                x: 7,
                y: 7,
                autoPaging: "text",

                html2canvas: {
                    scale: 0.73,
                    useCORS: true,
                }
            });
        };
        img.onerror = (err) => {
            console.error("Image load hone mein masla hua:", err);
            toast.error("Watermark logo load nahi ho saka!");
            setButtonLoader(false);
        };
    };

    const handleGenerateExcel = async () => {
        if (!invoiceNumber) {
            toast.error(t('invoice.invoiceNumberNotFound'), {
                className: 'errorToast',
            });
            return;
        }

        setButtonLoader(true);

        try {
            const workbook = new ExcelJS.Workbook();
            workbook.creator = 'Mayabridge';
            const worksheet = workbook.addWorksheet('Invoice');
            worksheet.columns = [
                // { width: 12 },
                // { width: 40 },
                // { width: 24 },
                { width: 8 },
                { width: 26 },
                { width: 36 },
                { width: 18 },
            ];

            const logoResponse = await fetch('/main-logo.png');
            const logoData = await logoResponse.blob();
            const logoBase64 = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result.split(',')[1]);
                reader.onerror = reject;
                reader.readAsDataURL(logoData);
            });

            const logoId = workbook.addImage({ base64: logoBase64, extension: 'png' });

            worksheet.mergeCells('A1:D3');

            worksheet.addImage(logoId, {
                tl: { col: 1, row: 0.2 },
                br: { col: 3, row: 2.8 },
            });

            worksheet.getCell('A4').value = t('invoice.invoiceNumberTitle', { invoiceNumber });
            worksheet.getCell('D4').value = `${t('invoice.dateLabel')}: ${formatDate(generatedInvoice?.billing_date || new Date())}`;
            worksheet.getCell('A4').font = { bold: true, size: 12 };
            worksheet.getCell('D4').font = { bold: true, size: 12 };

            const addSpecialProjectSection = (startRow, isCompressed = false) => {
                const projects = clientData?.special_project || [];
                if (projects.length === 0) return startRow;
                const specialProjectGroupByValue = clientData?.invoice_group_by || '';
                const specialProjectGroupByConfig = getSpecialProjectGroupByConfig(specialProjectGroupByValue);
                const groupedProjects = buildSpecialProjectGroups(projects, specialProjectGroupByConfig.join(','));

                let currentRow = startRow + 1;
                worksheet.mergeCells(currentRow, 1, currentRow, 4);
                worksheet.getCell(currentRow, 1).value = t('invoice.specialProject');
                worksheet.getCell(currentRow, 1).font = { bold: true, size: 12 };
                currentRow += 1;

                worksheet.getCell(currentRow, 1).value = '#';
                worksheet.getCell(currentRow, 2).value = t('invoice.description');
                worksheet.getCell(currentRow, 3).value = t('invoice.amount');
                worksheet.getCell(currentRow, 4).value = t('invoice.cost');
                [1, 2, 3, 4].forEach((column) => {
                    const cell = worksheet.getCell(currentRow, column);
                    cell.font = { color: { argb: 'FFFFFFFF' }, size: 12 };
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF015969' } };
                });
                currentRow += 1;

                let projectIndex = 0;
                groupedProjects.forEach((group) => {
                    if (specialProjectGroupByConfig.length > 0) {
                        worksheet.mergeCells(currentRow, 1, currentRow, 4);
                        worksheet.getCell(currentRow, 1).value = group.label;
                        worksheet.getCell(currentRow, 1).font = { bold: true, size: 12 };
                        currentRow += 1;
                    }
                    group.projects.forEach((project) => {
                    const translation = project?.translation || {};
                    const details = translation?.translation_details || {};
                    const targetLanguages = translation?.translation_target_languages
                        ?.map((target) => target?.language?.name)
                        .filter(Boolean)
                        .join(', ');
                    const projectStartRow = currentRow;
                    const addProjectField = (label, value) => {
                        if (value === null || value === undefined || value === '' || value === 'N/A') return;
                        worksheet.getCell(currentRow, 2).value = label;
                        worksheet.getCell(currentRow, 3).value = value;
                        currentRow += 1;
                    };

                    if (isCompressed) {
                        addProjectField(t('invoice.projectNumber'), translation?.transid);
                    } else {
                        addProjectField(t('invoice.projectNumber'), translation?.transid);
                        addProjectField(t('invoice.date'), translation?.created_at && formatDate(translation.created_at));
                        // addProjectField('Status', translation?.status);
                        addProjectField(t('invoice.subAccount'), translation?.subclient?.subaccount_name);
                        addProjectField(t('invoice.department'), translation?.translation_details?.department?.department_name);
                        if (Number(clientData?.interpreter_name_show_invoice) === 1) {
                            const vendorName = [project?.interpreter?.first_name, project?.interpreter?.last_name].filter(Boolean).join(' ');
                            addProjectField(t('invoice.vendorName'), vendorName);
                        }
                        addProjectField(t('invoice.sourceLanguage'), translation?.language?.name);
                        addProjectField(t('invoice.targetLanguage'), targetLanguages);
                        addProjectField(t('invoice.notes'), details?.notes || details?.comment);
                        if (Number(clientData?.requester_details_show_invoice) === 1) {
                            addProjectField(t('invoice.requesterName'), translation?.requester_name);
                            addProjectField(t('invoice.requesterEmail'), details?.requester_email);
                            addProjectField(t('invoice.requesterPhone'), details?.requester_phone);
                        }
                        addProjectField(t('invoice.currentPhase'), details?.current_phase);
                        addProjectField(
                            (() => {
                                const phase = details?.current_phase?.toLowerCase();
                                if (phase === 'review') return t('invoice.totalPageCount');
                                if (phase === 'transcription' || phase === 'other') return t('invoice.totalAudioMinutes');
                                return t('invoice.totalWordCount');
                            })(),
                            translation?.total_words_count
                        );

                        const rateUnit = (() => {
                            const phase = details?.current_phase?.toLowerCase();
                            if (phase === 'review') return t('invoice.perPage');
                            if (phase === 'transcription' || phase === 'other') return t('invoice.perMinute');
                            return t('invoice.perWord');
                        })();
                        addProjectField(t('invoice.rate'), `$${project?.rate || 0} ${rateUnit}`);
                        if (Number(project?.rush_fee || 0) > 0) addProjectField(t('invoice.rushFeeLine'), `$${project.rush_fee}`);
                        if (Number(project?.formatting || 0) > 0) addProjectField(t('invoice.formatting'), `$${project.formatting}`);
                    }

                    const projectEndRow = currentRow - 1;
                    if (projectEndRow >= projectStartRow) {
                        worksheet.mergeCells(projectStartRow, 1, projectEndRow, 1);
                        worksheet.mergeCells(projectStartRow, 4, projectEndRow, 4);
                        worksheet.getCell(projectStartRow, 1).value = ++projectIndex;
                        worksheet.getCell(projectStartRow, 1).alignment = { vertical: 'top', horizontal: 'left' };
                        worksheet.getCell(projectStartRow, 4).value = `$${formatCurrency(project?.amount)}`;
                        worksheet.getCell(projectStartRow, 4).alignment = { vertical: 'top', horizontal: 'left' };
                    }

                    currentRow += 1;
                    });
                });

                return currentRow;
            };

            const isCompressedInvoice = generatedInvoice?.invoice_type === 'compressed';

            if (isCompressedInvoice) {
                let currentRow = 5;

                const addSectionRow = (label, value, rowIndex) => {
                    worksheet.getCell(rowIndex, 1).value = label;
                    worksheet.getCell(rowIndex, 2).value = value;
                };

                worksheet.getCell(currentRow, 1).value = 'Bill To';
                worksheet.getCell(currentRow, 1).font = { bold: true, size: 12 };
                currentRow++;

                if (show(clientData?.user?.name)) {
                    addSectionRow(clientData.user.name, '', currentRow++);
                }

                if (show(clientData?.billing_person)) {
                    addSectionRow(clientData.billing_person, '', currentRow++);
                }

                if (show(clientData?.billing_email)) {
                    addSectionRow(clientData.billing_email, '', currentRow++);
                }

                if (show(clientData?.billing_zipcode || clientData?.city?.name)) {
                    addSectionRow(
                        `${clientData?.billing_zipcode || ''} ${clientData?.city?.name || ''}`.trim(),
                        '',
                        currentRow++
                    );
                }

                if (show(clientData?.state?.name)) {
                    addSectionRow(clientData.state.name, '', currentRow++);
                }

                if (clientData?.appointments?.length > 0) {
                    currentRow += 1;

                worksheet.mergeCells(currentRow, 1, currentRow, 4);
                worksheet.getCell(currentRow, 1).value = t('invoice.interpretation');
                worksheet.getCell(currentRow, 1).font = { bold: true, size: 12 };
                currentRow += 1;

                worksheet.getCell(currentRow, 1).value = '#';
                worksheet.getCell(currentRow, 2).value = t('invoice.description');
                worksheet.getCell(currentRow, 3).value = t('invoice.appointmentNumber');
                worksheet.getCell(currentRow, 4).value = t('invoice.cost');
                [1, 2, 3, 4].forEach(c => {
                    const cell = worksheet.getCell(currentRow, c);
                    cell.font = { bold: false, color: { argb: 'FFFFFFFF' }, size: 12 };
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF015969' } };
                });
                currentRow += 1;

                (clientData?.appointments || []).forEach((val, index) => {
                    worksheet.getCell(currentRow, 1).value = index + 1;
                    worksheet.getCell(currentRow, 2).value = 'Appointment Number';
                    worksheet.getCell(currentRow, 3).value = val?.appid || `Appointment ${index + 1}`;
                    worksheet.getCell(currentRow, 4).value = `$${formatCurrency(val?.invoice?.total_amount)}`;
                    currentRow += 1;
                });
                }

                currentRow = addSpecialProjectSection(currentRow, true);
                worksheet.mergeCells(currentRow, 1, currentRow, 3);
                worksheet.getCell(currentRow, 1).value = t('invoice.totalDue');
                worksheet.getCell(currentRow, 1).font = { bold: true };
                worksheet.getCell(currentRow, 1).alignment = { horizontal: 'right' };
                worksheet.getCell(currentRow, 4).value = `$${formatCurrency(
                    (clientData?.appointments || []).reduce((sum, item) => sum + (item?.invoice?.total_amount || 0), 0) +
                    (clientData?.special_project || []).reduce((sum, project) => sum + Number(project?.amount || 0), 0)
                )}`;
                worksheet.getCell(currentRow, 4).font = { bold: true };
                // worksheet.getCell('A6').value = 'Compressed Invoice';
                // worksheet.getCell('A6').font = { bold: true, size: 12 };
                // worksheet.getCell('A7').value = 'Appointment Number';
                // worksheet.getCell('B7').value = 'Total';
                // worksheet.getCell('A7').font = { bold: true };
                // worksheet.getCell('B7').font = { bold: true };

                // let currentRow = 8;
                // (clientData?.appointments || []).forEach((val, index) => {
                //     worksheet.getCell(currentRow, 1).value = val?.appid || `Appointment ${index + 1}`;
                //     worksheet.getCell(currentRow, 2).value = `$${formatCurrency(val?.invoice?.total_amount)}`;
                //     currentRow += 1;
                // });

                // worksheet.getCell(currentRow, 1).value = 'Total Due';
                // worksheet.getCell(currentRow, 1).font = { bold: true };
                // worksheet.getCell(currentRow, 2).value = `$${formatCurrency(clientData?.appointments?.reduce((sum, item) => sum + (item?.invoice?.total_amount || 0), 0))}`;
                // worksheet.getCell(currentRow, 2).font = { bold: true };
            } else {
                const addSectionRow = (label, value, rowIndex) => {
                    worksheet.getCell(rowIndex, 1).value = label;
                    worksheet.getCell(rowIndex, 2).value = value;
                };

                let currentRow = 5;
                worksheet.getCell(currentRow, 1).value = t('invoice.billTo');
                worksheet.getCell(currentRow, 1).font = { bold: true, size: 12 };
                currentRow += 1;

            if (show(clientData?.user?.name)) {
                addSectionRow(clientData.user.name, '', currentRow);
                currentRow += 1;
            }
            if (show(clientData?.billing_person)) {
                addSectionRow(clientData.billing_person, '', currentRow);
                currentRow += 1;
            }
            if (show(clientData?.billing_email)) {
                addSectionRow(clientData.billing_email, '', currentRow);
                currentRow += 1;
            }
            if (show(clientData?.billing_zipcode || clientData?.city?.name)) {
                addSectionRow(`${clientData?.billing_zipcode || ''} ${clientData?.city?.name || ''}`.trim(), '', currentRow);
                currentRow += 1;
            }
            if (show(clientData?.state?.name)) {
                addSectionRow(clientData.state.name, '', currentRow);
                currentRow += 1;
            }

            if (clientData?.appointments?.length > 0) {
            currentRow += 1;
            // worksheet.getCell(currentRow, 1).value = 'Appointment Details';
            worksheet.mergeCells(currentRow, 1, currentRow, 4);
            worksheet.getCell(currentRow, 1).value = t('invoice.interpretation');
            worksheet.getCell(currentRow, 1).font = { bold: true, size: 12 };
            currentRow += 1;

            // Table header row
            worksheet.getCell(currentRow, 1).value = '#';
            worksheet.getCell(currentRow, 2).value = t('invoice.description');
            worksheet.getCell(currentRow, 3).value = t('invoice.amount');
            worksheet.getCell(currentRow, 4).value = t('invoice.cost');
            [1, 2, 3, 4].forEach(c => {
                const cell = worksheet.getCell(currentRow, c);

                cell.font = {
                    bold: false,
                    color: { argb: 'FFFFFFFF' },
                    size: 12
                };

                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FF015969' }
                };
            });
            currentRow += 1;

            // const groupByConfig = getInvoiceGroupByConfig(clientData?.appointments || [], clientData?.invoice_group_by || generatedInvoice?.invoice_group_by || '');
            const groupByConfig = getInvoiceGroupByConfig(clientData?.invoice_group_by || '');
            const groupedAppointments = buildInvoiceGroups(clientData?.appointments || [], groupByConfig.join(','));

            groupedAppointments.forEach((group, groupIndex) => {
                // if (groupByConfig.length > 0) {
                //     worksheet.getCell(currentRow, 1).value = group.label;
                //     worksheet.getCell(currentRow, 1).font = { bold: true };
                //     currentRow += 1;
                // }
                if (groupByConfig.length > 0) {
                    worksheet.mergeCells(currentRow, 1, currentRow, 4);
                    worksheet.getCell(currentRow, 1).value = group.label;
                    // worksheet.getCell(currentRow, 1).font = { bold: true };
                    currentRow += 1;
                }

                group.appointments.forEach((val, index) => {
                    const totalHours = val?.invoice?.total_hours;
                    const totalMinutes = totalHours
                        ? (parseInt(totalHours.split(':')[0], 10) * 60) + parseInt(totalHours.split(':')[1], 10)
                        : 0;
                    const minDuration = val?.invoice?.min_duration;
                    const minDurUnit = val?.invoice?.duration_unit;
                    const minDurationMinutes = minDurUnit === 'hour' ? minDuration * 60 : minDuration;
                    const isValid = totalMinutes >= minDurationMinutes;
                    const inc = val?.invoice?.incremental;
                    const incremental =
                        inc === '30_minute' ? '30 minute' :
                        inc === '1_hour' ? 'hourly' :
                        inc === 'minute' ? 'per minute' : null;

                    const exceededTime = getExceededTime(
                        val.date,
                        val.end_time,
                        val.appointment_assign?.checkin_date,
                        val.appointment_assign?.checkout_time
                    );
                    const fullDuration = getFullDuration(
                        val.appointment_assign?.checkin_date,
                        val.appointment_assign?.checkin_time,
                        val.appointment_assign?.checkout_date,
                        val.appointment_assign?.checkout_time
                    );
                    // const hasCustomPricing = !!val?.appointment_custom_pricing;

                    const customPricing = val?.appointment_custom_pricing;
                    const hasCustomPricing =
                    Number(customPricing?.mileage_total || 0) > 0 ||
                    Number(customPricing?.travel_total || 0) > 0 ||
                    Number(customPricing?.discount || 0) > 0 ||
                    Number(val?.invoice?.rush_fee || 0) > 0;

                    // worksheet.getCell(currentRow, 1).value = `${index + 1}. Appointment`;
                    // worksheet.getCell(currentRow, 1).font = { bold: true };
                    // currentRow += 1;
                    const addSectionRow = (label, value, rowIndex) => {
                        worksheet.getCell(rowIndex, 2).value = label;
                        worksheet.getCell(rowIndex, 3).value = value;
                    };
                    const apptStartRow = currentRow;

                    if (show(val?.appid)) {
                        addSectionRow(t('invoice.appointmentNumber'), val.appid, currentRow);
                        currentRow += 1;
                    }
                    if (show(val?.language?.name)) {
                        addSectionRow(t('invoice.language'), val.language.name, currentRow);
                        currentRow += 1;
                    }
                    if (show(val?.status) && val.status !== 'completed') {
                        addSectionRow(t('invoice.status'), val.status, currentRow);
                        currentRow += 1;
                    }
                    if (show(val?.date)) {
                        const timezone = val?.appointment_details?.timezone?.name;
                        
                        let formattedDate = moment(val.date).format('DD/MM/YYYY');
    
                        if (timezone) {
                            const dateTime = moment.tz(
                                `${val.date} ${val.start_time || '00:00:00'}`,
                                'YYYY-MM-DD HH:mm:ss',
                                timezone
                            );
    
                            formattedDate = `${dateTime.format('DD/MM/YYYY')}`;
                        }
                        addSectionRow(t('invoice.date'), formattedDate, currentRow);
                        // addSectionRow('Date', `${moment(val.date).format('DD/MM/YYYY')} (${val?.appointment_details?.timezone?.abbreviation || ''} / GMT${val?.appointment_details?.timezone?.utc_offset || ''})`.trim(), currentRow);
                        currentRow += 1;
                    }
                    if (show(val?.type)) {
                        const minDurationText = minDuration ? ` (min duration: ${minDuration} ${minDurUnit || ''})`.trim() : '';
                        addSectionRow(t('invoice.modality'), `${val.type}${minDurationText ? ' ' + minDurationText : ''}`, currentRow);
                        // addSectionRow('Modality', val.type, currentRow);
                        currentRow += 1;
                    }
                    if (show(val?.subject)) {
                        addSectionRow(t('invoice.type'), val.subject + (incremental ? ` (${t('invoice.incremental')}: ${incremental})` : ''), currentRow);
                        currentRow += 1;
                    }
                    // if (show(val?.start_time) && show(val?.date)) {
                    //     const scheduledCrossesMidnight = val?.end_time &&
                    //         moment(val.end_time, 'HH:mm:ss').isBefore(moment(val.start_time, 'HH:mm:ss'));

                    //     if (scheduledCrossesMidnight) {
                    //         addSectionRow(
                    //             t('invoice.scheduledStartDateTime'),
                    //             `${moment(val.date).format('DD/MM/YYYY')} ${moment(val.start_time, 'HH:mm:ss').format('h:mm A')}`,
                    //             currentRow
                    //         );
                    //     } else {
                    //         addSectionRow(t('invoice.scheduledStartTime'), moment(val.start_time, 'HH:mm:ss').format('h:mm A'), currentRow);
                    //     }
                    //     currentRow += 1;
                    // } else if (show(val?.start_time)) {
                    //     addSectionRow(t('invoice.scheduledStartTime'), moment(val.start_time, 'HH:mm:ss').format('h:mm A'), currentRow);
                    //     currentRow += 1;
                    // }
                    const scheduledStart = getScheduledStartTime(
                        val?.date,
                        val?.start_time,
                        val?.end_time,
                        val?.appointment_details?.timezone
                    );

                    if (scheduledStart) {
                        addSectionRow(scheduledStart.label, scheduledStart.value, currentRow);
                        currentRow += 1;
                    } else if (show(val?.start_time)) {
                        addSectionRow(
                            t('invoice.scheduledStartTime'),
                            moment(val.start_time, 'HH:mm:ss').format('h:mm A'),
                            currentRow
                        );
                        currentRow += 1;
                    }
                    if (show(val?.estimated_duration)) {
                        addSectionRow(t('invoice.scheduledDuration'), `${val?.estimated_duration} ${val?.estimated_duration_unit}`, currentRow);
                        currentRow += 1;
                    }
                    const actualStart = renderActualStartTime(
                        val?.appointment_assign?.checkin_date,
                        val?.appointment_assign?.checkin_time,
                        val?.appointment_assign?.checkout_date,
                        val?.appointment_assign?.checkout_time
                    );

                    if (actualStart) {
                        addSectionRow(actualStart.label, actualStart.value, currentRow);
                        currentRow++;
                    }
                    if (fullDuration) {
                        addSectionRow(t('invoice.actualDuration'), fullDuration, currentRow);
                        currentRow += 1;
                    }
                    if (fullDuration) {
                        addSectionRow(t('invoice.totalBillableDuration'), `${val?.invoice?.extra_duration || 0} ${t('invoice.minutes')}`, currentRow);
                        currentRow += 1;
                    }
                    if (show(val?.invoice?.rate)) {
                        addSectionRow(t('invoice.rate'), `$${val.invoice.rate}/${val.invoice.rate_unit || ''}`, currentRow);
                        currentRow += 1;
                    }
                    if (val?.invoice?.rush_fee > 0) {
                        addSectionRow(t('invoice.rushFeeLine'), `$${val.invoice.rush_fee}`, currentRow);
                        currentRow += 1;
                    }
                    if (show(val?.appointment_details?.facility?.facility_name)) {
                        addSectionRow(t('invoice.facilityName'), val.appointment_details.facility.facility_name, currentRow);
                        currentRow += 1;
                    }
                    if (show(val?.appointment_details?.requester_name)) {
                        addSectionRow(t('invoice.requestorName'), val.appointment_details.requester_name, currentRow);
                        currentRow += 1;
                    }
                    if (show(val?.appointment_details?.requester_email)) {
                        addSectionRow(t('invoice.requestorEmail'), val.appointment_details.requester_email, currentRow);
                        currentRow += 1;
                    }
                    if (show(val?.appointment_details?.requester_phone)) {
                        addSectionRow(t('invoice.requestorPhone'), val.appointment_details.requester_phone, currentRow);
                        currentRow += 1;
                    }
                    if (show(val?.interpreter && `${val.interpreter.id}`)) {
                        addSectionRow(t('invoice.vendorId'), `${val.interpreter.code}`, currentRow);
                        currentRow += 1;
                    }
                    if (show(val?.interpreter && `${val.interpreter.first_name} ${val.interpreter.last_name}`)) {
                        addSectionRow(t('invoice.vendorName'), `${val.interpreter.first_name} ${val.interpreter.last_name}`, currentRow);
                        currentRow += 1;
                    }
                    if (show(val?.appointment_assign?.comments)) {
                        addSectionRow(t('invoice.comments'), val.appointment_assign.comments, currentRow);
                        currentRow += 1;
                    }

                    const dynamicFieldsList = (() => {
                        try {
                            const parsed = val?.appointment_details?.dynamic_fields
                                ? JSON.parse(val.appointment_details.dynamic_fields)
                                : [];
                            return Array.isArray(parsed) ? parsed.filter(f => f?.show_in_invoice === true) : [];
                        } catch {
                            return [];
                        }
                    })();

                    if (dynamicFieldsList.length > 0) {
                        addSectionRow('Extra Fields', '', currentRow);
                        worksheet.getCell(currentRow, 2).font = { bold: true };
                        currentRow += 1;

                        dynamicFieldsList.forEach((f) => {
                            if (f?.value) {
                            addSectionRow(f?.name || '', f?.value || '', currentRow);
                            currentRow += 1;
                            }
                        });
                    }

                    if (val?.invoice) {
                        if (hasCustomPricing) {
                            addSectionRow(t('invoice.costBreakdown'), '', currentRow);
                            worksheet.getCell(currentRow, 2).font = { bold: true };
                            currentRow += 1;
                            addSectionRow(t('invoice.rate'), `$${val?.invoice?.rate}/${val.invoice.rate_unit || ''} × ${val?.invoice?.extra_duration || 0} ${t('invoice.minutes')}`, currentRow);
                            currentRow += 1;
                            if (val?.appointment_custom_pricing?.mileage_total > 0) {
                                addSectionRow(`+ ${t('invoice.mileageTotal')}`, `$${val.appointment_custom_pricing.mileage_total}`, currentRow);
                                currentRow += 1;
                            }
                            if (val?.appointment_custom_pricing?.travel_total > 0) {
                                addSectionRow(`+ ${t('invoice.travelTotal')}`, `$${val.appointment_custom_pricing.travel_total}`, currentRow);
                                currentRow += 1;
                            }
                            // if ((val?.appointment_custom_pricing?.sub_total > 0 && val?.appointment_custom_pricing?.discount > 0)) {
                            //     addSectionRow('= Sub Total', `$${val.appointment_custom_pricing.sub_total}`, currentRow);
                            //     currentRow += 1;
                            // }
                            if (val?.appointment_custom_pricing?.discount > 0) {
                                addSectionRow(`+ ${t('invoice.discount')}`, `${val.appointment_custom_pricing.discount}%`, currentRow);
                                currentRow += 1;
                            }
                            if (val?.invoice?.rush_fee > 0) {
                                addSectionRow(`+ ${t('invoice.rushFeeLine')}`, `$${val.invoice.rush_fee}`, currentRow);
                                currentRow += 1;
                            }
                            addSectionRow(`= ${t('invoice.totalCost')}`, `$${formatCurrency(val?.invoice?.total_amount)}`, currentRow);
                            currentRow += 1;
                        } else {
                            addSectionRow(t('invoice.totalCost'), `$${formatCurrency(val?.invoice?.total_amount)}`, currentRow);
                            currentRow += 1;
                        }
                    }

                    // if (exceededTime) {
                    //     addSectionRow('Exceeded Time', exceededTime, currentRow);
                    //     currentRow += 1;
                    // }

                    // if (isValid === false || incremental) {
                    //     addSectionRow('Incremental', incremental || '', currentRow);
                    //     currentRow += 1;
                    // }

                    const apptEndRow = currentRow - 1;
                    if (apptEndRow >= apptStartRow) {
                        if (apptEndRow > apptStartRow) {
                            worksheet.mergeCells(apptStartRow, 1, apptEndRow, 1);
                            worksheet.mergeCells(apptStartRow, 4, apptEndRow, 4);
                        }
                        worksheet.getCell(apptStartRow, 1).value = index + 1;
                        // worksheet.getCell(apptStartRow, 1).font = { bold: true };
                        worksheet.getCell(apptStartRow, 1).alignment = { vertical: 'top', horizontal: 'left' };

                        worksheet.getCell(apptStartRow, 4).value = `$${formatCurrency(val?.invoice?.total_amount)}`;
                        // worksheet.getCell(apptStartRow, 4).font = { bold: true };
                        worksheet.getCell(apptStartRow, 4).alignment = { vertical: 'top', horizontal: 'left' };
                    }

                    currentRow += 1;
                });
            });

                // worksheet.getCell(currentRow, 1).value = 'Total Due';
                // worksheet.getCell(currentRow, 1).font = { bold: true };
                // worksheet.getCell(currentRow, 2).value = `$${formatCurrency(clientData?.appointments?.reduce((sum, item) => sum + (item?.invoice?.total_amount || 0), 0))}`;
                // worksheet.getCell(currentRow, 2).font = { bold: true };
                }

                currentRow = addSpecialProjectSection(currentRow, false);

                worksheet.mergeCells(currentRow, 1, currentRow, 3);
                worksheet.getCell(currentRow, 1).value = t('invoice.totalDue');
                worksheet.getCell(currentRow, 1).alignment = { horizontal: 'right' };
                // worksheet.getCell(currentRow, 1).font = { bold: true };
                worksheet.getCell(currentRow, 4).value = `$${formatCurrency(
                    (clientData?.appointments || []).reduce((sum, item) => sum + (item?.invoice?.total_amount || 0), 0) +
                    (clientData?.special_project || []).reduce((sum, project) => sum + Number(project?.amount || 0), 0)
                )}`;
                // worksheet.getCell(currentRow, 4).font = { bold: true };
            }

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = `${invoiceNumber || 'invoice'}.xlsx`;
            anchor.click();
            window.URL.revokeObjectURL(url);

            toast.success(t('billing.downloadInvoicesSuccess'), {
                className: 'successToast',
            });
        } catch (error) {
            console.error(t('invoice.excelGenerateFailed'), error);
            toast.error(t('invoice.excelGenerateFailed'), {
                className: 'errorToast',
            });
        } finally {
            setButtonLoader(false);
        }
    };

    const handleDownloadSelection = async () => {
        const result = await Swal.fire({
            title: t('billing.downloadInvoice'),
            text: t('billing.downloadFormatPrompt'),
            showDenyButton: true,
            confirmButtonText: t('billing.downloadPdf'),
            denyButtonText: t('billing.downloadExcel'),
            reverseButtons: true,
            customClass: {
                denyButton: 'swal-btn',
                confirmButton: 'swal-btn',
            },
        });

        if (result.isConfirmed) {
            handleGeneratePdf();
        } else if (result.isDenied) {
            handleGenerateExcel();
        }
    };
    return (
        <div className="content">
            <div className='row_savebtn'>
                <div className='d-flex align-items-center gap-2'>
                    <button className="main_heading back_button" onClick={() => navigate(-1)}>
                        <i className="fa-solid fa-arrow-left"></i> {t('common.back')}
                    </button>
                </div>
                <div className='d-flex align-items-center gap-2'>
                {generatedInvoice?.status !== 'Paid' && (
                    <Link to={`/invoices/edit-view/${id}`} className="main_button text-nowrap">{t('billing.editInvoice')}</Link>
                )}    
                <Link to={`/invoices/history/${id}`} className="main_button text-nowrap">{t('billing.invoiceHistory')}</Link>
                <SubmitButton
                    handleSubmit={handleDownloadSelection}
                    buttonType={'button'}
                    loader={buttonLoader}
                    btnText={t('billing.downloadInvoice')}
                />
                </div>
            </div>
            <div ref={invoiceRef} className='view_pdf_main'>
                <PdfForm data={generatedInvoice} loader={loader} type={generatedInvoice?.invoice_type}/>
            </div>
        </div>
    );
};

export default AllPdfView;
